import cx from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "../modal-new";

const icons = {
  delete: "/img/new-icons/red-trash.svg",
};
function ConfirmationModal(props) {
  const { t } = useTranslation("common");
  const {
    title,
    contentText,
    cancelButtonText,
    cancelButtonAction,
    confirmButtonText,
    confirmButtonAction,
    isOpen,
    reduceSize,
    icon,
    // Small pill (reuses the app-wide .chip.warning look) shown above the
    // title - e.g. a plain "Warning" label, kept separate from `contentText`
    // so callers can lead with a short flag before the actual message.
    badgeText,
    confirmSuccess,
    toClear = [],
    className,
  } = props;

  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      className={cx("confirmation-modal", className)}
      header={false}
      toClear={toClear}
    >
      <div className={reduceSize ? "reduced-confirmation-modal body" : "body"}>
        {icon && icons[icon] && (
          <div>
            <img src={icons[icon]} alt={t("confirmationModal.deleteIconAlt")} />
          </div>
        )}
        {badgeText && <span className="chip warning">{badgeText}</span>}
        <h3 className="text-center">{title}</h3>
        <p>{contentText}</p>
      </div>
      <footer id="confirmation-modal-footer">
        <button data-button-type="secondary" onClick={cancelButtonAction}>
          <span>{cancelButtonText}</span>
        </button>
        <button
          data-button-type={confirmSuccess ? "primary" : "secondary"}
          data-action={confirmSuccess ? undefined : "cancel"}
          onClick={confirmButtonAction}
        >
          {confirmButtonText}
        </button>
      </footer>
    </Modal>
  );
}

export default ConfirmationModal;
